<script lang="ts">
    // import Botones from './components/Botones.vue';
    import { defineComponent } from "vue";
    
    export default defineComponent({
        components: { 
            
        },
        setup() {
            // Aquí se llama al composable useHead
        },    
        data() {
            return {
            showImage: true,
            showImage2: true,
            showImage3: true,
            videoUrl: "https://www.youtube.com/embed/766G4yP1Y2w?si=m-X0wZGudiQFu1Q_",
            videoUrl2: "https://www.youtube.com/embed/G0nRBBZiZZQ?si=5bKZPQIeH-9Opx62",
            videoUrl3: "https://www.youtube.com/embed/EHjQwUjIViY?si=A12sGhrrpFxd7Iyh",
            image1: "./pagesImages/decisiones.jpg",
            image2: "./pagesImages/play-icon.png",
            image3: "./pagesImages/play-2.png",
            // pathImgs: '/pagesImages/',
            // currentCucamanImage: 'cuco-1.png',
            // currentLeusImage: 'leus-1.png',
            // showCucamanDiv: false,
            // showLeusDiv: false,
            // buttons: {
            //         button1: { imageUrl: "/pagesImages/explorar_off.png", hoverImageUrl: "/pagesImages/explorar_on.png" },
            //         button2: { imageUrl: "/pagesImages/conocelos_off.png", hoverImageUrl: "/pagesImages/conocelos_on.png" },
            //         button3: { imageUrl: "/pagesImages/leer_off.png", hoverImageUrl: "/pagesImages/leer_on.png" },
            //         button4: { imageUrl: "/pagesImages/inscribete_off.png", hoverImageUrl: "/pagesImages/inscribete_on.png" },
            //         button5: { imageUrl: "/pagesImages/visit-trasp.png", hoverImageUrl: "/pagesImages/visitanos_on.png" },
            //     },
            };
        },
        methods: {
            showVideo() {
                this.showImage = false;
            },
            showVideo2() {
                this.showImage2 = false;
            },
            showVideo3() {
                this.showImage3 = false;
            },
            // changeImage(type: string, isHover: boolean) {
            //     if (type === 'cucaman') {
            //         this.currentCucamanImage = isHover ? 'cuco-2.png' : 'cuco-1.png';
            //         this.showCucamanDiv = isHover;
            //     } else if (type === 'leus') {
            //         this.currentLeusImage = isHover ? 'leus-2.png' : 'leus-1.png';
            //         this.showLeusDiv = isHover;
            //     }
            // },
            // getCucamanImage() {
            //     return this.pathImgs + this.currentCucamanImage;
            // },
            // getLeusImage() {
            //     return this.pathImgs + this.currentLeusImage;
            // },
        },
    });
</script>

<template>
    <div class="mb-12">
        <img src="/pagesImages/muro-humanitas-logotipo.webp" alt="Imagen de muro de Universidad Humanitas" class="object-cover object-center h-[400px] md:h-auto w-screen pt-[88px] lg:pt-[143px]" fetchpriority="high"  loading="eager" decoding="async">
    </div>
    <section class="flex w-full justify-center">
        <div class="flex flex-col items-center justify-center w-full max-w-4xl lg:max-w-[1200px]">
            <div class="flex flex-col mb-12 items-center justify-center w-full px-4">
                <h1 class="text-[36px] leading-tight text-hgold font-serif mb-1">ACERCA DE UNIVERSIDAD HUMANITAS</h1>
                <h2 class="text-[30px] leading-tight text-hgold font-serif mb-5">FUNDADA EN 1979</h2>
                <p class="text-[24px] leading-tight mb-5 text-hgray">S&oacute;lo el conocimiento hace superior al hombre</p>
                <p class="mb-0 w-full text-[18px] leading-tight lg:w-1/2">Impulsamos la educación a través de tres modelos educativos, con un enfoque en la excelencia académica y la transmisión de valores. Ofrecemos instalaciones de primer nivel y costos accesibles, con el propósito de fortalecer la educación y brindar a más personas la oportunidad de acceder a una formación integral y de calidad.</p>
            </div>
            <div class="flex justify-center items-center w-full">
                <div class="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-12 px-4 items-center">
                    <div class="flex flex-col justify-center items-center relative text-white text-left w-full max-w-[480px] ">
                        <img src="/pagesImages/busto-humanitas.webp" alt="Busto Humanitas" class="">
                        <div class="absolute bottom-10 lg:bottom-9 md:mx-4 mx-2">
                            <h2 class=" text-center text-hwine text-[28px] mb-2">MISI&Oacute;N</h2>
                            <p class="leading-5 text-gray-800 text-center w-full">Enaltecer la dignidad humana a trav&eacute;s de la educaci&oacute;n y el ejercicio de nuestros valores.</p>
                        </div>
                    </div>
                    <div class="flex flex-col justify-center items-center relative text-white text-left w-full max-w-[480px] ">
                        <img src="/pagesImages/edificio-humanitas.webp" alt="Edificio Humanitas">
                        <div class="absolute bottom-10 lg:bottom-9 md:mx-4 mx-2">
                            <h2 class="text-center text-hwine text-[28px] mb-2">VISI&Oacute;N</h2>
                            <p class="leading-5 text-gray-800 text-center w-full">Impulsar la educaci&oacute;n apeg&aacute;ndonos a nuestra filosof&iacute;a, con sistemas pr&aacute;cticos y excelencia acad&eacute;mica.</p>
                        </div>
                    </div>
                    <div class="flex flex-col justify-center items-center relative text-white text-left w-full max-w-[480px] ">
                        <img src="/pagesImages/bandera-humanitas.webp" alt="Bandera Humanitas">
                        <div class="absolute bottom-[14px]  mx-3">
                            <h2 class="text-center text-hwine text-[28px] mb-2">VALORES</h2>
                            <ul class="leading-5 text-gray-800 w-full list-disc">
                                <li>Disciplina</li>
                                <li>Justicia</li>
                                <li>Respeto</li>
                                <li>Responsabilidad</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="flex flex-col w-full h-full items-center justify-center mb-12" style="background-image: url(/pagesImages/columnas-bg.webp); position: relative; background-attachment: fixed; background-position: center; background-repeat: no-repeat; background-size: cover; overflow: hidden; transition: transform 0.3s ease;">
        <div class="w-full max-w-4xl lg:max-w-[1200px]">
            <div class="flex flex-col items-center mt-20 mb-12 justify-center w-full">
                <h2 class="font-serif text-gray-600 text-4xl mb-4 w-full">Humanitas en el tiempo</h2>
                <p class="px-4 text-gray-600">A lo largo de las décadas, hemos evolucionado sin perder de vista nuestro <br class="md:block hidden"> compromiso con la excelencia académica y el desarrollo humano.</p>
            </div>
            <div class="flex items-center justify-center mb-12 w-full">
                <div class="flex flex-col text-left text-gray-600 justify-start px-4">
                    <div class="flex-col mb-6">
                        <div class="flex lg:hidden items-center mb-4">
                            <div class="flex md:hidden justify-center w-[40%]">
                                <img src="/pagesImages/logotipo-despacho-Johnson&Okhuysen.png" loading="lazy" alt="Logo del despacho Johnson&Okuysen. Donde se inicio el proyecto de crear un centro de investigación y más adelante dio pie a Humanitas." class="h-[60px]">
                            </div>
                            <p class="font-times text-4xl w-[60%] md:w-full text-center">1979</p>
                        </div>
                        <div class="flex w-full space-x-4 items-center">
                            <div class="hidden md:flex justify-center w-[40%] lg:w-[176px]">
                                <img src="/pagesImages/logotipo-despacho-Johnson&Okhuysen.png" loading="lazy" alt="Logo del despacho Johnson&Okuysen. Donde se inicio el proyecto de crear un centro de investigación y más adelante dio pie a Humanitas." class="h-full mx-5">
                            </div>
                            <div class="w-full lg:w-[500px]">
                                <p class="hidden md:flex text-[42px] font-serif uppercase">1979</p>
                                <h2 class="text-lg my-2 uppercase">Cimientos sólidos para un legado académico</h2>
                                <ul class="list-disc pl-5">
                                    <li>El 30 de abril se funda la Universidad Humanitas.</li>
                                    <li>Dr. Eduardo Johnson Okhuysen es fundador de la institución.</li>
                                    <li>Se inaugura el primer campus en la Ciudad de México.</li>
                                    <li>Los valores, la misión, la visión son diseñados junto con el lema institucional "Sólo el conocimiento hace superior al hombre".</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="flex-col mb-6">
                        <div class="flex lg:hidden items-center mb-4">
                            <div class="flex md:hidden justify-center w-[40%]">
                                <img src="/pagesImages/escribano-diseno-humanitas.png" loading="lazy" alt="Diseño de escribano en la identidad visual de Humanitas" class="h-[60px]">
                            </div>
                            <p class="font-times text-4xl w-[60%] md:w-full text-center">1980-1989</p>
                        </div>
                        <div class="flex w-full space-x-4 items-center">
                            <div class="hidden md:flex justify-center w-[40%] lg:w-[176px]">
                                <img src="/pagesImages/escribano-diseno-humanitas.png" loading="lazy" alt="Diseño de Escribano en la identidad visual de Humanitas" class="h-full mx-5">
                            </div>
                            <div class=" w-full lg:w-[500px]">
                                <p class="hidden md:flex text-[42px] font-serif uppercase">1980-1989</p>
                                <h2 class="text-lg my-2 uppercase">Crecimiento y consolidación</h2>
                                <ul class="list-disc pl-5">
                                    <li>Creación del Centro de investigación de Estudios.</li>
                                    <li>Desarrollo y diseño de los planes de estudio de Posgrado.</li>
                                    <li>La Secretaría de Educación Pública (SEP) otorga el reconocimiento oficial de Posgrados.</li>
                                    <li>Se inicia la publicación de libros de Derecho, Economía y negocios, Política y finanzas.</li>
                                    <li>Nace el despacho jurídico Johnson Okhuysen Asociados con fines sociales.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="flex-col mb-6">
                        <div class="flex lg:hidden items-center mb-4">
                            <div class="flex md:hidden justify-center w-[40%]">
                                <img src="/pagesImages/escribano-evolucion-humanitas.png" loading="lazy" alt="Evolución de Escribano en la imagen de Humanitas" class="h-[60px]">
                            </div>
                            <p class="font-times text-4xl w-[60%] md:w-full text-center">1990-1999</p>
                        </div>
                        <div class="flex w-full space-x-4 items-center">
                            <div class="hidden md:flex justify-center w-[40%] lg:w-[176px]">
                                <img src="/pagesImages/escribano-evolucion-humanitas.png" loading="lazy" alt="Evolución de Escribano en la imagen de Humanitas" class="h-full mx-5">
                            </div>
                            <div class=" w-full lg:w-[500px]">
                                <p class="hidden md:flex text-[42px] font-serif uppercase">1990-1999</p>
                                <h2 class="text-lg my-2 uppercase">Innovación y reconocimiento</h2>
                                <ul class="list-disc pl-5">
                                    <li>Se establece el sistema educativo abierto.</li>
                                    <li>Los planes de estudio para la Licenciatura se estructuran con un enfoque innovador y de calidad.</li>
                                    <li>
                                        La SEP otorga reconocimiento oficial de Licenciaturas.
                                    </li>
                                    <li>Para fortalecer el proceso de aprendizaje se introducen guías de estudio para las Licenciaturas.</li>
                                    <li>El 12 de julio de 1996 fallece el fundador.</li>
                                    <li>
                                        En 1999, Andrés Johnson Islas asume la Dirección General.
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="flex-col mb-6">
                        <div class="flex lg:hidden items-center mb-4">
                            <div class="flex md:hidden justify-center w-[40%]">
                                <img src="/pagesImages/diseno-evolucion-logotipo-humanitas.png" loading="lazy" alt="Proceso de evolución del logotipo de Humanitas" class="h-[60px]">
                            </div>
                            <p class="font-times text-4xl w-[60%] md:w-full text-center">2000-2009</p>
                        </div>
                        <div class="flex w-full space-x-4 items-center">
                            <div class="hidden md:flex justify-center w-[40%] lg:w-[176px]">
                                <img src="/pagesImages/diseno-evolucion-logotipo-humanitas.png" loading="lazy" alt="Proceso de evolución del logotipo de Humanitas" class="h-full mx-5">
                            </div>
                            <div class=" w-full lg:w-[500px]">
                                <p class="hidden md:flex text-[42px] font-serif uppercase">2000-2009</p>
                                <h2 class="text-lg my-2 uppercase">Avances en la era digital</h2>
                                <ul class="list-disc pl-5">
                                    <li>Es renovado el logotipo institucional, reflejando la visión de la Universidad.</li>
                                    <li>Reestructuración del modelo educativo.</li>
                                    <li>La arquitectura neoclásica se convierte en un símbolo de nuestra identidad y se redefine en los Campus.</li>
                                    <li>Inauguración de los Campus Magno de Tijuana y Cancún.</li>
                                    <li>Se define la estructura del Corporativo Humanitas.</li>
                                    <li>Nuevos programas académicos son integrados a la oferta académica.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="flex-col mb-6">
                        <div class="flex lg:hidden items-center mb-4">
                            <div class="flex md:hidden justify-center w-[40%]">
                                <img src="/pagesImages/capitel-logotipo-humanitas.png" loading="lazy" alt="Logotipo de la revista Capitel de la Universidad Humanitas" class="h-[60px]">
                            </div>
                            <p class="font-times text-4xl w-[60%] md:w-full text-center">2010-2019</p>
                        </div>
                        <div class="flex w-full space-x-4 items-center">
                            <div class="hidden md:flex justify-center w-[40%] lg:w-[176px]">
                                <img src="/pagesImages/capitel-logotipo-humanitas.png" loading="lazy" alt="Logotipo de la revista Capitel de la Universidad Humanitas" class="h-[60px] md:h-full mx-5">
                            </div>
                            <div class=" w-full lg:w-[500px]">
                                <p class="hidden md:flex text-[42px] font-serif uppercase">2010-2019</p>
                                <h2 class="text-lg my-2 uppercase">Identidad y liderazgo</h2>
                                <ul class="list-disc pl-5">
                                    <li>Humanitas refuerza su identidad institucional con la creación de Leus y Cucaman, mascotas oficiales.</li>
                                    <li>Surge el modelo educativo English Kingdom y el concepto Deli Despierta.</li>
                                    <li>Se implementa el modelo educativo por bloques.</li>
                                    <li>Expande su presencia con la apertura de nuevos campus en Los Reyes, Presa Madín, Querétaro, Mérida, Guadalajara, Cuernavaca y Santa Fe.</li>
                                    <li>Inicia el programa virtual con Licenciaturas y Posgrados.</li>
                                    <li>Creación de la Fundación Fuerza H y Humanitas Vive.</li>
                                    <li>En 2015, nace la revista Capitel.</li>
                                    <li>La calidad institucional es reconocida con certificaciones en Empresa Socialmente Responsable (ESR) y Great Place to Work (GPTW).</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="flex-col mb-6">
                        <div class="flex lg:hidden items-center mb-4">
                            <div class="flex md:hidden justify-center w-[40%]">
                                <img src="/pagesImages/trascendi-logotipo-humanitas.png" loading="lazy" alt="Logotipo de Trascendi, el canal de entrevistas de la Universidad Humanitas" class="h-[60px]">
                            </div>
                            <p class="font-times text-4xl w-[60%] md:w-full text-center">2020-2026</p>
                        </div>
                        <div class="flex w-full space-x-4 items-center">
                            <div class="hidden md:flex justify-center w-[40%] lg:w-[176px]">
                                <img src="/pagesImages/trascendi-logotipo-humanitas.png" loading="lazy" alt="Logotipo de Trascendi, el canal de entrevistas de la Universidad Humanitas" class="h-full ">
                            </div>
                            <div class=" w-full lg:w-[500px]">
                                <p class="hidden md:flex text-[42px] font-serif uppercase">2020-2026</p>
                                <h2 class="text-lg my-2 uppercase">Transformación y futuro</h2>
                                <ul class="list-disc pl-5">
                                    <li>Los canales Trascendi y Legatum surgen y destacan como espacios diseñados para inspirar, informar y enriquecer el aprendizaje.</li>
                                    <li>Se desarrolla el plan de estudios para Doctorado.</li>
                                    <li>La SEP otorga el reconocimiento oficial de Doctorado.</li>
                                    <li>Expande su icónica arquitectura neoclásica en sus Campus ya establecidos.</li>
                                    <li>A nivel geográfico, se amplía la presencia, ahora en Chihuahua y Monterrey.</li>
                                    <li>Expande el modelo virtual a Bogotá, Colombia.</li>
                                    <li>Presencia en Riviera Maya y Puebla.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="flex flex-col w-full items-center justify-center">
        <div class="lg:flex items-center justify-between max-w-4xl lg:max-w-[1200px] mb-12">
            <div class="flex flex-col w-full lg:mr-12 px-4 Lg:mb-0 mb-6">
                <div class="flex flex-col justify-center items-center lg:items-start my-4 w-full">
                    <h3>
                        <span class="block md:text-left text-[28px] text-gray-500 leading-none mr-2 lg:mr-0">Universidad Humanitas</span>
                        <span class="sr-only whitespace-nowrap">&nbsp;</span>
                        <span class="block md:text-left text-[42px] text-hgold leading-none font-serif">desde 1979</span>
                    </h3>
                </div>
                <p class=" text-justify mb-2">Hemos sido un referente de educación de calidad, guiada por una filosofía apegada a valores y en búsqueda de la superación continua, la disciplina y la búsqueda del conocimiento como pilares fundamentales.</p>
                <p class=" text-justify">Nuestro objetivo es impulsar el desarrollo integral de sus estudiantes, formándolos como profesionales y como seres humanos comprometidos con su crecimiento personal y con la sociedad. A lo largo de los años, hemos mantenido firme la misión de ofrecer una educación que prepare a los individuos para enfrentar los retos de la vida con sabiduría y equilibrio.</p>
            </div>
            <div class="flex items-center justify-center w-full">
                <VideoHiL :thumbnailUrl="'/pagesImages/relojarena.webp'" alt="47 años de Universidad Humanitas" :videoUrl="'https://www.youtube.com/embed/gMCkceBIVvY?si=kf_K0gqwdIOYn56t'" class="w-[539px] mb-2"/>
            </div>
        </div>

        <div class="flex items-center w-full justify-center max-w-4xl lg:max-w-[1200px] mb-12">
            <div class="lg:flex w-full items-center justify-between"> 
                <div class="flex items-center justify-center" >
                    <img src="/pagesImages/filosofia-campus-chihuahua.webp" alt="Estatua Campus Chihuahua" class="lg:mr-12 mb-2 w-[539px] " />
                </div>
                <div class="flex flex-col justify-center lg:w-[50%] w-[100%] text-left px-4">
                    <div class="flex lg:flex-col justify-center lg:items-start items-center my-4 w-full">
                        <h2>
                            <span class="block md:text-left text-center text-[28px] text-gray-500 leading-none mr-2 lg:mr-0">Filosof&iacute;a</span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block md:text-left text-center text-[42px] text-hgold leading-none font-serif">De vida</span>
                        </h2>
                    </div>
                    <ul class="list-disc pl-5 ">
                        <li>Mente: Expandir el conocimiento mediante el estudio y el trabajo.</li>
                        <li>Cuerpo: Preservar la salud a través de una alimentación equilibrada y actividad física.</li>
                        <li class="mb-2">
                            Alma y espíritu: Cultivar valores, pensamientos y acciones positivas para el bienestar de la humanidad, los animales y el medio ambiente.
                        </li>
                    </ul>
                    <div class="flex flex-col items-end justify-end mb-2">
                        <p class=" italic font-montse " style="font-style:italic">
                            "Somos lo que hacemos día a día. De modo que la excelencia no es un acto, sino un hábito."
                        </p>
                        <p class=" text-right"
                        >— Aristóteles</p>
                    </div>
                    <h2 class="mt-4 mb-2 text-lg">C&Oacute;DIGO HUMANITAS</h2>
                    <ol class="list-decimal list-inside ">
                        <li> Vivo y actúo con respeto.</li>
                        <li> Soy congruente en pensamiento, acción y palabra.</li>
                        <li> Todas mis actividades las realizo con orgullo, pasión y responsabilidad.</li>
                        <li> Encuentro mi camino hacia la superación en la educación.</li>
                        <li> Los obstáculos me permiten caminar cada vez más firme.</li>
                        <li> Lo imposible lo convierto en posible.</li>
                        <li> Sé que mis acciones de hoy determinarán el mañana.</li>
                        <li> Llegar al éxito y concretar mis sueños depende de mi actitud.</li>
                    </ol>
                </div>
            </div>
        </div>

        <div class="flex flex-col lg:flex-row items-center justify-between max-w-4xl lg:max-w-[1200px] mb-12">
            <div class="order-2 lg:order-1 flex flex-col lg:w-[50%] w-[100%] lg:mr-12 px-4">
                <div class="flex flex-col justify-center items-center lg:items-start my-4 w-full">
                    <h2>
                        <span class="block md:text-left text-center text-[28px] text-gray-500 leading-none mr-2 lg:mr-0">¿Por qu&eacute; estudiar en</span>
                        <span class="sr-only whitespace-nowrap">&nbsp;</span>
                        <span class="block md:text-left text-center text-[42px] text-hgold leading-none font-serif">Humanitas?</span>
                    </h2>
                </div>
                <p class="text-justify mb-2">Impulsamos y formamos personas con valores y conocimientos profesionales en diversas áreas de estudio, bajo una filosofía de respeto al entorno y búsqueda constante de superación.</p>
                <p class=" text-justify mb-2">Tenemos presencia en diversas entidades de la República Mexicana. Nuestros campus magnos, con arquitectura neoclásica, cuentan con jardines y fuentes diseñados para inspirar el estudio y la reflexión.</p>
                <p class=" text-justify mb-2">Por otro lado, nuestros campus ejecutivos destacan por su arquitectura vanguardista, que combina elegancia con un ambiente acogedor.</p>
                <p class=" text-justify mb-2">Nuestros modelos educativos, diseñados por especialistas y supervisados por el consejo académico, garantizan que las horas en el aula, las actividades y los horarios contribuyan al desarrollo integral de los alumnos.</p>
                <br>
                <div class="flex items-center justify-center lg:justify-end">
                    <router-link to="/contacto">
                        <div class="flex items-center justify-center w-[140px] h-[35px] hover:bg-hwine bg-hgold text-white text-lg transition duration-300 ease-in-out">
                            <span>Inscr&iacute;bete</span>
                        </div>
                    </router-link>
                </div>
            </div>
            <div class="order-1 lg:order-2 flex items-center justify-center">
                <img src="/pagesImages/egresados-universidad-humanitas.webp" loading="lazy" alt="Egresados de Universidad Humanitas">
            </div>
        </div>

        <div class="lg:flex justify-between w-full max-w-4xl lg:max-w-[1200px] items-center mb-16">
            <div class="lg:flex w-full items-center justify-between"> 
                <div class="flex items-center justify-center">
                    <img src="/pagesImages/docente-humanitas.webp" alt="Docente Humanitas" class="lg:mr-12 w-full mb-2"/>
                </div>
                <div class="flex flex-col justify-center lg:w-[50%] w-[100%] text-left px-4">
                    <div class="flex lg:flex-col justify-center lg:items-start items-center my-4 w-full">
                        <h2>
                            <span class="block md:text-left text-center text-[28px] text-gray-500 leading-none mr-2 lg:mr-0">Docentes</span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block md:text-left text-center text-[42px] text-hgold leading-none font-serif">Humanitas</span>
                        </h2>
                    </div>
                    <p class="mb-2 text-justify">Contamos con destacados catedráticos, expertos en sus respectivas profesiones, quienes laboran tanto en el sector gubernamental como en el privado. Comparten nuestra vocación por la enseñanza, transmitiendo sus conocimientos con un enfoque que promueve el razonamiento y la resolución de problemas para alcanzar el aprendizaje, utilizando una metodología práctica y de alta calidad académica.</p>
                    <p class="mb-2 text-justify">Definen tanto sus acciones como las de los estudiantes dentro del sistema institucional, con el objetivo de lograr los resultados esperados y abordar las lecturas de manera práctica, mediante experiencias laborales y casos reales que se gestionan a través del proceso de evaluación.</p>
                    <p class="mb-2 text-justify">Su enfoque es activo, modelando las acciones de los alumnos hasta lograr transmitirles el conocimiento de forma efectiva. La exigencia es alta, ya que el compromiso del estudiante está centrado en un solo bloque y un único docente por trimestre.</p>
                    <p class=" text-justify">Los docentes de la Universidad Humanitas desempeñan su labor en prestigiosos despachos, consultorios, bufetes, empresas e instituciones de alto nivel.</p>
                </div>
            </div>
        </div>
    </section>

    <EgresadosHuma :types="'Nosotros'"/>

    <section class="flex flex-col items-center justify-center bg-cover bg-[bottom bg-no-repeat" style="background-image: url(/pagesImages/mascotas.webp);">
        <div class="flex flex-col justify-center items-center mb-4 mt-12">
            <h2 class="font-serif text-hgold text-4xl">Nuestras Mascotas</h2>
            <p class=" text-lg">Representan la dualidad que vive en nuestro interior. Entre el bien y el mal,</p>
            <p class=" text-lg">¿Qui&eacute;n ganar&aacute;? Al que alimentes m&aacute;s.</p>
        </div>
        <div class="flex flex-col w-full max-w-4xl lg:max-w-[1200px]  h-full  justify-start mb-60 mt-4">
            <div class="flex flex-col md:flex-row justify-center md:justify-between lg:px-0 px-4">
                <div id="leus-div" class="flex-col w-full lg:w-[280px] bg-white/90 border border-hwine text-base p-5 rounded-lg mb-4 md:mb-0 md:mr-4 lg:mr-0">
                    <h3 class="font-acuminbold mb-3 text-4xl text-center text-hwine tracking-widest">Leus</h3>
                    <p class="font-montse text-sm text-center mb-4 text-black tracking-normal">
                        Representa los valores, las virtudes y la importancia de vivir bajo una filosofía que nos permita crecer y desarrollarnos como seres humanos, manteniendo un equilibrio entre cuerpo, mente y espíritu.
                    </p>
                </div>
                <div id="cucaman-div"  class="flex-col w-full lg:w-[280px] bg-white/90 border border-hwine text-base p-5 rounded-lg">
                    <h3 class="font-acuminbold mb-3 text-4xl text-center text-hwine tracking-widest">Cucaman</h3>
                    <p class="font-montse text-sm text-center mb-4 text-black tracking-normal">
                        Representa los vicios, las debilidades y la indiferencia ante la necesidad de vivir según una filosofía que favorezca el crecimiento y desarrollo personal o profesional. Vive de manera desbalanceada, priorizando el éxito inmediato o el placer personal, sin atender el bienestar integral.
                    </p>
                </div>
            </div>
        </div>
    </section>

    <!-- <section class="flex w-full h-full items-center justify-center bg-cover bg-[center] bg-no-repeat " style="background-image: url(/pagesImages/portada-12-pelotas.webp);">
        <div class="w-full bg-white bg-opacity-50 flex flex-col items-center justify-center">
            <div class="flex items-center w-full max-w-4xl lg:max-w-[1200px] justify-center ">
                <div class="lg:flex justify-start w-full my-20 items-center">
                    <div class="flex flex-col justify-start lg:w-[70%] lg:px-0 px-4">
                        <div class="text-center lg:text-left mb-4 leading-none">
                            <h3>
                                <span class="block text-hwine text-[28px]">Las 12 Pelotas</span>
                                <span class="sr-only whitespace-nowrap">&nbsp;</span>
                                <span class="block text-hwine text-[42px] font-serif">De la Felicidad</span>
                            </h3>
                        </div>
                        <div class="text-justify ">
                            <p class="mb-4">La vida es como un juego de malabares en el que dispones de 12 pelotas para lograr la felicidad.</p>
                            <p>Es normal que siempre se caiga una o m&aacute;s pelotas… lo importante es contar con la actitud y perseverancia de volver a levantarlas para mantener un equilibrio en la vida y, como consecuencia, obtener la felicidad con la filosof&iacute;a de estar siempre en un continuo movimiento.</p>
                        </div>
                    </div>
                    <div class="flex  w-full items-center md:pl-12 lg:justify-start justify-center">
                        <VideoHiL :thumbnailUrl="'/pagesImages/icono-play-video.png'" :videoUrl="videoUrl3" class="w-full lg:mt-0 mt-8"/>
                    </div>
                </div> 
            </div>
        </div>
    </section> -->

    <section class="flex items-center w-full justify-center">
        <div class="lg:flex items-center max-w-4xl lg:max-w-[1200px]">
            <div class="flex items-center w-full justify-center">
                <img src="/pagesImages/shield-tr.png" loading="lazy" alt="Escudo">
            </div>
            <div class="flex justify-center w-full items-center px-4 mb-10">
                <div class="flex flex-col justify-center items-center lg:items-start w-full">
                    <h2 class="md:text-left text-center">
                        <span class="block text-[28px] leading-none">Plataforma</span>
                        <span class="sr-only whitespace-nowrap">&nbsp;</span>
                        <span class="block text-hgold leading-none mb-2 font-serif text-[42px]">Humanitas</span>
                    </h2>
                    <p class="text-justify mb-2">Acceso fácil y rápido a información clave como horarios, finanzas, historial académico, avisos, calendarios, expediente personal, eventos y redes sociales.</p>
                    <p class="text-justify mb-2">Soporte en plataformas de alto desempeño, como Google Workspace, que ofrece a estudiantes y docentes, acceso a correos personalizados y diversas herramientas colaborativas para mejorar la comunicación y productividad.</p>
                    <p class="text-justify">Ingreso a la Biblioteca Virtual, para consultar y adquirir libros electrónicos, los cuales pueden descargarse en distintos dispositivos, con recursos académicos en todo momento.</p>
                    <br>
                    <router-link to="/usuarios">
                        <div class="flex items-center justify-center w-[140px] h-[35px] hover:bg-hwine bg-hgold text-white text-lg transition duration-300 ease-in-out">
                            <span>Acceder</span>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </section>

    <section class="flex items-center justify-center bg-cover bg-[center] bg-no-repeat" style="background-image: url(/pagesImages/despierta.webp);">
        <div class="flex flex-col w-full max-w-4xl h-full justify-start my-14 md:my-24 text-white px-4">
            <div class="flex flex-col justify-center items-center lg:items-start">
                <img src="/pagesImages/logotipo-despierta-gde.png" loading="lazy" alt="Despierta" class="max-w-[394px] mb-2 max-h-[172px]">
                <h2 class=" sr-only">Despierta</h2>
                <p class="text-center lg:text-justify w-full max-w-[460px] mb-3">Un concepto de cafetería que combina una alimentación saludable con el sabor genuino que despertará todos tus sentidos. Ofrecemos opciones nutritivas, pensadas para quienes desean disfrutar de una comida equilibrada sin perder la esencia del buen sabor.</p>
                <p class="text-center lg:text-justify w-full max-w-[460px] italic mb-4" ><em>"Que tu alimento sea tu medicina y tu medicina sea tu alimento."</em></p>
                <p class="text-center lg:text-right w-full max-w-[460px] mb-4">-Hipócrates</p>
                <router-link to="/despierta">
                    <div class="flex items-center justify-center w-[140px] h-[35px] bg-white/70 hover:bg-hgold text-hwine border border-hwine text-lg font-semibold transition duration-300 ease-in-out">
                        <span>Vis&iacute;tanos</span>
                    </div>
                </router-link>
            </div>
        </div>
    </section>
</template>

<style scoped>
</style>